/* eslint-disable @typescript-eslint/prefer-as-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import Box from '@mui/material/Box';
import { Button, Divider, MobileStepper, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router';
import './register.css'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: 'background.paper',
    boxShadow: 20,
    p: 0,
  };

export default function RegisterConfirmation():JSX.Element {  
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down('md'));
    const { t } = useTranslation();
  const {userDataAndStatus} = useSelector((state:any) => state.registerScreenReducer)
    const navigate = useNavigate()

    const handleLogin = () => {
        navigate('/login')
    }
 
  return (
      <div id="main">
          <Box
              sx={
                  md
                      ? {
                            position: 'absolute' as 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'background.paper',
                            boxShadow: 20,
                            p: 0,
                        }
                      : style
              }
          >
              <Paper elevation={0} sx={{ paddingTop: 2, paddingBottom: 3, paddingLeft: 3, paddingRight: 2 }}>
                  <Stack direction={'column'} spacing={2}>
                  <Typography variant="h6">{t('lbl_accntActivation')}</Typography>
                      <Typography sx={{wordWrap:'break-word'}} variant="body1">
                      {t('msg_accntActivation')} “{userDataAndStatus?.data?.login}”. <br />
                      
                          {t('lbl_accntActivationEmailSent')}
                          <br />
                      </Typography>
                  </Stack>
              </Paper>
              <Divider />
              <MobileStepper
                  variant="dots"
                  steps={0}
                  position="static"
                  activeStep={0}
                  sx={
                      md
                          ? {
                                zIndex: 1000,
                                position: 'fixed',
                                top: '100vh',
                                transform: 'translateY(-100%)',
                                width: '100%',
                                p: 2,
                                backgroundColor: 'inherit',
                            }
                          : {
                                maxWidth: 400,
                                flexGrow: 1,
                                paddingTop: 2,
                                paddingBottom: 2,
                                paddingLeft: 3,
                                paddingRight: 3,
                                backgroundColor: 'inherit',
                            }
                  }
                  nextButton={
                      <Button size="medium" variant="contained" onClick={handleLogin}>
                          {t('lbl_login')}
                      </Button>
                  }
                  backButton={undefined}
              />
          </Box>
      </div>
  );
}
